module.exports = __webpack_public_path__ + "img/16.0280ff75.gif";